<div class="row mb-2 mr-0 pl-3 pb-0"  *ngIf="global.docbool">
    <div class="col ml-1">
        <div widget class="card border-0 box-shadow">
                <div class="row">
                    <div class="col b-col">
                        <div class="b1">
                            <h4 class="mb-0 font-header">Client</h4>
                        </div>
                        <div class="b2">
                            <button class="btn btn-sm px-3" (click)="backToClientOnboardingList()" *ngIf="clientonboardBO.edit"><i
                                    class=" fa fa-arrow-left mr-1"></i>Close</button>
                        </div>
                    </div>
                </div>   
        </div>
    </div>
</div>


<app-files  *ngIf="global.docbool"
    [clientonboardBO]="clientonboardBO"></app-files>


